import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateCampaignTemplateComponent } from './create-campaign-template.component';

const routes: Routes = [{ path: '', component: CreateCampaignTemplateComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CreateCampaignTemplateRoutingModule { }
